import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { catchError, map, Observable, of } from 'rxjs';
import { GlobalVariables } from '../model/global-variables';
import { AuthenticateService } from '../service/authenticate/authenticate.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import {BehaviorService} from "../service/behavior.service";
import {AppSettings} from "../../app.settings";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  public globalVariables = new GlobalVariables();

  constructor(
    private _authService: AuthenticateService,
    private appSettings: AppSettings,
    private router: Router,
    private snackBar: MatSnackBar,
    private _behaviorService: BehaviorService
  ) { }

  // Extrai a mensagem de aviso/erro retornada pelo back-end, em qualquer formato comum
  private extractBackendMessage(error: HttpErrorResponse): string | null {
    const err = error?.error;
    if (typeof err === 'string' && err.trim()) {
      try {
        const parsed = JSON.parse(err);
        return parsed?.message || parsed?.error || err;
      } catch {
        return err;
      }
    }
    if (err && typeof err === 'object') {
      if (typeof err.message === 'string' && err.message.trim()) { return err.message; }
      if (typeof err.error === 'string' && err.error.trim()) { return err.error; }
      if (Array.isArray(err.errors) && err.errors.length) {
        return err.errors.map((e: any) => e?.message || e).join('\n');
      }
    }
    return null;
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.globalVariables.Token;

    if (request.url.includes('notification') && request.method == 'POST' || request.headers.get('Skip-interceptor') == 'true') {
      return next.handle(request)
        .pipe(
          map((event: HttpEvent<any>) => {
            return event;
          })
        );
    }
    else {
      const newRequest = request.clone({
        headers: request.headers.set('Authorization', token ? `Bearer ${token}` : '')
      });

      setTimeout(() => {

        if (['POST', 'PUT'].includes(request.method) && !request.headers.get('Skip-loading')) {
          this._behaviorService.messageWaitAMomement.next('Aguarde um momento, por favor');
          this._behaviorService.waitAMoment.next(true);
        }
      });

      return next.handle(newRequest)
        .pipe(
          map((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              this._behaviorService.waitAMoment.next(false);
            }
            return event;
          }), catchError((error: HttpErrorResponse) => {
            this._behaviorService.waitAMoment.next(false);
            if (error.status == 401) {
              this._authService.logout();
            }

            const backendMessage = this.extractBackendMessage(error);

            // Exibe na tela toda mensagem de aviso/erro vinda do back-end
            if (error.status == 404) {
              this.snackBar.open(backendMessage || 'Nenhum registro foi encontrado.', 'Fechar', { duration: 5000 });
            } else if (error.status != 401) {
              this.snackBar.open(backendMessage || 'Ocorreu um erro ao processar a requisição.', 'Fechar', { duration: 8000 });
            }

            return of(new HttpResponse({
              body: {
                success: false,
                data: error?.error,
                message: backendMessage || error?.message,
              }
            }));
          })
        );
    }
  }
}
